module.exports = __webpack_public_path__ + "03_short_brown.b6e9afd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/03_short_brown.png
// module id = LYCb
// module chunks = 0